import type OpenApp from '@base/utils/open-app'
import { Browser } from '@base/utils/open-app'
import { isMobile } from '@fe/utils'
import cn from 'classnames'
import { Fragment, useMemo, useState } from 'react'
import { Toast } from 'zarm'
import { sensorsTrack } from '../../utils/sensors'
import s from './form.module.scss'

interface P {
  openApp: OpenApp
  setVisible: (visible: boolean) => void
}
function Home(props: P) {
  const { setVisible, openApp } = props
  const [phone, setPhone] = useState('')
  return useMemo(() => {
    return (
      <Fragment>
        <div className={s['form-mask']} />
        <form
          onSubmit={() => {
            // 验证
            if (!isMobile(phone)) {
              //
              Toast.show('请输入正确的手机号码')
              return
            }

            sensorsTrack('PhonePost', 'H5手机号提交按钮点击', {
              gotoapp_type: Browser.isAndroid ? 'Android' : Browser.isIos ? 'iOS' : 'H5',
              phone_encryption: window?.btoa(phone) || null,
            })

            openApp.open()
            setVisible(false)
          }}
        >
          <div className={s.registerForm}>
            <div className={s.inner}>
              <div className={s.title}>请预留您的手机号</div>
              <div className={s.form}>
                <input
                  className={s.ipt}
                  placeholder="请输入手机号码"
                  value={phone}
                  maxLength={11}
                  onChange={(e) => {
                    setPhone(e.target.value)
                  }}
                />
              </div>
              <div className={s.btns}>
                <button className={cn(s.btn)} type="submit" disabled={phone.length < 11}>
                  确定
                </button>
              </div>
            </div>
            <div
              className={s.close}
              onClick={() => {
                openApp.open()
                setVisible(false)
              }}
            />
          </div>
        </form>
      </Fragment>
    )
  }, [openApp, phone, setVisible])
}

export default Home
